import { LazyLoader as bdtv_3710caabd7c0 } from "@Bondit2Theme/mod-fipefi";
import * as bdtv_35b0c8a58aef from "@Bondit2Theme/mod-fozane";
import { CustomElement as bdtv_36cb401d2a50 } from "@Bondit2Theme/mod-ratamo";
import { eventModal as bdtv_1eba8d5ad935 } from "@Bondit2Theme/mod-kodati";

class bdtv_18f3918dec58 extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = bdtv_35b0c8a58aef.debounce((bdtv_8a87c8b7050d) => {
      this.onSubmitHandler(bdtv_8a87c8b7050d);
    }, 500);

    const bdtv_00977becd8c3 = this.querySelector("form");
    if (bdtv_00977becd8c3) {
      bdtv_00977becd8c3.addEventListener("input", this.debouncedOnSubmit.bind(this));
    }
  }

  static setListeners() {
    const bdtv_2974e062bbce = (bdtv_69e091405ac7) => {
      const bdtv_9bc779eac445 = bdtv_69e091405ac7.state
        ? bdtv_69e091405ac7.state.searchParams
        : bdtv_18f3918dec58.searchParamsInitial;
      if (bdtv_9bc779eac445 === bdtv_18f3918dec58.searchParamsPrev) return;
      bdtv_18f3918dec58.renderPage(bdtv_9bc779eac445, null, false);
    };
    window.addEventListener("popstate", bdtv_2974e062bbce);
  }

  static toggleActiveFacets(bdtv_bb7c8111c21a = true) {
    document.querySelectorAll(".js-facet-remove").forEach((bdtv_1b4df4a64498) => {
      bdtv_1b4df4a64498.classList.toggle("bdt-inerte", bdtv_bb7c8111c21a);
    });
  }

  static renderPage(bdtv_aa7002833248, bdtv_d068127b5c38, bdtv_d918ec8fb51f = true) {
    bdtv_18f3918dec58.searchParamsPrev = bdtv_aa7002833248;
    const bdtv_f1e5c86ef3ea = bdtv_18f3918dec58.getSections();
    bdtv_f1e5c86ef3ea.forEach((bdtv_6ed1c64d6fe1) => {
      const bdtv_ef4dbc75aa9c = `${window.location.pathname}?section_id=${bdtv_6ed1c64d6fe1.section}&${bdtv_aa7002833248}`;
      const bdtv_de3b4a7ce658 = (bdtv_d5a001f9f57d) => bdtv_d5a001f9f57d.url === bdtv_ef4dbc75aa9c;
      bdtv_18f3918dec58.filterData.some(bdtv_de3b4a7ce658)
        ? bdtv_18f3918dec58.renderSectionFromCache(bdtv_de3b4a7ce658, bdtv_d068127b5c38)
        : bdtv_18f3918dec58.renderSectionFromFetch(bdtv_ef4dbc75aa9c, bdtv_d068127b5c38);
    });

    if (bdtv_d918ec8fb51f) bdtv_18f3918dec58.updateURLHash(bdtv_aa7002833248);
  }

  static renderSectionFromFetch(bdtv_7fc2ab2dba0c, bdtv_b9dbf58c88e3) {
    document.getElementById("ProductsGridContainer").classList.add("bdt-carregando2");
    bdtv_35b0c8a58aef.getBody().classList.add("bdt-carregando2");
    const bdtv_47db1dcca5b6 = document.querySelector("#ProductsGridContainer");
    let bdtv_37cd80d3c96f = 0;
    if (bdtv_47db1dcca5b6.querySelector(".bdt-linha2-etapas2")) {
      bdtv_37cd80d3c96f =
        bdtv_47db1dcca5b6.querySelector(".bdt-linha2-etapas2").offsetHeight + 150;
    }
    window.scrollTo({
      top:
        bdtv_47db1dcca5b6.getBoundingClientRect().top +
        window.scrollY -
        110 +
        bdtv_37cd80d3c96f,
      behavior: "smooth",
    });
    fetch(bdtv_7fc2ab2dba0c)
      .then((bdtv_0bb557452567) => bdtv_0bb557452567.text())
      .then((bdtv_bf3c08683422) => {
        const bdtv_529acd155ee4 = bdtv_bf3c08683422;
        bdtv_18f3918dec58.filterData = [
          ...bdtv_18f3918dec58.filterData,
          { html: bdtv_529acd155ee4, url: bdtv_7fc2ab2dba0c },
        ];
        const bdtv_9bca81370973 = new DOMParser().parseFromString(bdtv_529acd155ee4, "text/html");
        bdtv_18f3918dec58.renderFilters(bdtv_9bca81370973, bdtv_b9dbf58c88e3);
        bdtv_18f3918dec58.renderProductContainer(bdtv_9bca81370973);
        bdtv_18f3918dec58.renderProductCount(bdtv_9bca81370973);
        new bdtv_3710caabd7c0(".bdt-figura-zora-no");
      });
  }

  static renderSectionFromCache(bdtv_cb723fc863fa, bdtv_fa2cdd1f0bb7) {
    document.getElementById("ProductsGridContainer").classList.add("bdt-carregando2");
    bdtv_35b0c8a58aef.getBody().classList.remove("bdt-carregando2");
    const bdtv_3e706b5b5477 = document.querySelector("#ProductsGridContainer");
    let bdtv_feef8b5c90cf = 0;
    if (bdtv_3e706b5b5477.querySelector(".bdt-linha2-etapas2")) {
      bdtv_feef8b5c90cf =
        bdtv_3e706b5b5477.querySelector(".bdt-linha2-etapas2").offsetHeight + 150;
    }
    window.scrollTo({
      top:
        bdtv_3e706b5b5477.getBoundingClientRect().top +
        window.scrollY -
        110 +
        bdtv_feef8b5c90cf,
      behavior: "smooth",
    });
    const bdtv_94259628ee59 = bdtv_18f3918dec58.filterData.find(bdtv_cb723fc863fa).html;
    const bdtv_f9add75a75cc = new DOMParser().parseFromString(bdtv_94259628ee59, "text/html");
    bdtv_18f3918dec58.renderFilters(bdtv_f9add75a75cc, bdtv_fa2cdd1f0bb7);
    bdtv_18f3918dec58.renderProductContainer(bdtv_f9add75a75cc);
    bdtv_18f3918dec58.renderProductCount(bdtv_f9add75a75cc);
    new bdtv_3710caabd7c0(".bdt-figura-zora-no");
  }

  static renderProductContainer(bdtv_5858285217b5) {
    const bdtv_2aabcd927930 = bdtv_5858285217b5.querySelector(".bdt-linha2__rive .bdt-linha2--vazio2"
    );
    if (bdtv_2aabcd927930) {
      document.getElementById("CollectionGird").innerHTML =
        bdtv_5858285217b5.getElementById("CollectionGird").innerHTML;
    } else {
      document.getElementById("CollectionGird").innerHTML =
        bdtv_5858285217b5.getElementById("CollectionGird").innerHTML;
    }
  }

  static renderProductCount(bdtv_aadbfb0d6510) {
    const bdtv_ae7998a2dbf0 = (bdtv_8607a63c622a) => {
      if (bdtv_8607a63c622a == "bdt-faceta2-gaveta") {
        if (
          window.innerWidth < 1025 ||
          !document.querySelector("#FacetFiltersForm")
        ) {
          return;
        }
      }
      const bdtv_d627efd3880b = bdtv_aadbfb0d6510.querySelector(`.${bdtv_8607a63c622a}`);
      const bdtv_4aa76a50762e = document.querySelector(`.${bdtv_8607a63c622a}`);
      if (bdtv_d627efd3880b && bdtv_4aa76a50762e) {
        bdtv_4aa76a50762e.innerHTML = bdtv_d627efd3880b.innerHTML;
      }
    };

    const bdtv_aa75a7a58d04 = [
      "bdt-linha2-contagem2",
      "bdt-facetas2-peneiras-ativo2",
      "bdt-facetas2-peneiras-gaveta-ativo2",
      "bdt-seletor2-ordem2.bdt-faceta2-peneiras",
      "bdt-gaveta-ordem2.bdt-faceta2-peneiras",
      "bdt-paginado-no-vo",
      "bdt-faceta2-gaveta",
    ];
    bdtv_aa75a7a58d04.forEach(bdtv_ae7998a2dbf0);
  }

  static renderFilters(bdtv_cf8ff6068ad1, bdtv_e48084e83538) {
    const bdtv_7117e55853d7 = bdtv_cf8ff6068ad1.querySelectorAll("#FacetFiltersForm .js-bdt-peneira, #FacetFiltersFormDrawer .js-bdt-peneira"
    );
    const bdtv_669506f4592d = (bdtv_19278d46a317) => {
      const bdtv_f14a3a2ce3c4 = bdtv_e48084e83538 ? bdtv_e48084e83538.target.closest(".js-bdt-peneira") : undefined;
      return bdtv_f14a3a2ce3c4
        ? bdtv_19278d46a317.dataset.bdtDize === bdtv_f14a3a2ce3c4.dataset.bdtDize
        : false;
    };
    const bdtv_3bfafb906172 = Array.from(bdtv_7117e55853d7).filter(
      (bdtv_acdd6741f075) => !bdtv_669506f4592d(bdtv_acdd6741f075)
    );

    const bdtv_8086d68e6967 = Array.from(bdtv_7117e55853d7).find(bdtv_669506f4592d);
    bdtv_3bfafb906172.forEach((bdtv_0926fbfdce63) => {
      if (
        document.querySelector(
          `.js-bdt-peneira[data-bdt-dize="${bdtv_0926fbfdce63.dataset.bdtDize}"]`
        )
      ) {
        document.querySelector(
          `.js-bdt-peneira[data-bdt-dize="${bdtv_0926fbfdce63.dataset.bdtDize}"]`
        ).innerHTML = bdtv_0926fbfdce63.innerHTML;
      }
    });

    if (
      bdtv_cf8ff6068ad1.querySelector(".bdt-bo-peneira-aplicar2") &&
      document.querySelector(".bdt-bo-peneira-aplicar2")
    ) {
      document.querySelector(".bdt-bo-peneira-aplicar2").innerHTML =
        bdtv_cf8ff6068ad1.querySelector(".bdt-bo-peneira-aplicar2").innerHTML;
    }

    if (
      bdtv_cf8ff6068ad1.querySelector(".bdt-bo-peneira-faceta2") &&
      document.querySelector(".bdt-bo-peneira-faceta2")
    ) {
      document.querySelector(".bdt-bo-peneira-faceta2").innerHTML =
        bdtv_cf8ff6068ad1.querySelector(".bdt-bo-peneira-faceta2").innerHTML;
    }

    bdtv_18f3918dec58.renderActiveFacets(bdtv_cf8ff6068ad1);

    if (bdtv_8086d68e6967)
      bdtv_18f3918dec58.renderCounts(
        bdtv_8086d68e6967,
        bdtv_e48084e83538.target.closest(".js-bdt-peneira")
      );
    document
      .getElementById("ProductsGridContainer")
      .classList.remove("bdt-carregando2");
    bdtv_35b0c8a58aef.getBody().classList.remove("bdt-carregando2");
  }

  static renderActiveFacets(bdtv_9356bc207998) {
    bdtv_18f3918dec58.toggleActiveFacets(false);
  }

  static renderCounts(bdtv_6ab0be02fc58, bdtv_b7e4ba3e6415) {
    const bdtv_0e1bdc5f10c8 = bdtv_b7e4ba3e6415.querySelector(".bdt-facetas2__eleito");
    const bdtv_11f838c4d2f0 = bdtv_6ab0be02fc58.querySelector(".bdt-facetas2__eleito");

    const bdtv_f0c8cec9c32a = bdtv_b7e4ba3e6415.querySelector(".facets__summary");
    const bdtv_964966fd219b = bdtv_6ab0be02fc58.querySelector(".facets__summary");

    if (bdtv_11f838c4d2f0 && bdtv_0e1bdc5f10c8) {
      bdtv_b7e4ba3e6415.querySelector(".bdt-facetas2__eleito").outerHTML =
        bdtv_6ab0be02fc58.querySelector(".bdt-facetas2__eleito").outerHTML;
    }

    if (bdtv_f0c8cec9c32a && bdtv_964966fd219b) {
      bdtv_b7e4ba3e6415.querySelector(".facets__summary").outerHTML =
        bdtv_6ab0be02fc58.querySelector(".facets__summary").outerHTML;
    }
  }

  static updateURLHash(bdtv_c89d3d825ae2) {
    history.pushState(
      { searchParams: bdtv_c89d3d825ae2 },
      "",
      `${window.location.pathname}${bdtv_c89d3d825ae2 && "?".concat(bdtv_c89d3d825ae2)}`
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.bdtVopa,
      },
    ];
  }

  createSearchParams(bdtv_46e15bc567da) {
    const bdtv_811d9ff9a0ee = new FormData(bdtv_46e15bc567da);
    const bdtv_1c8a45bd957f = new FormData();
    for (let [bdtv_0469b5764c45, bdtv_d2143a864834] of bdtv_811d9ff9a0ee.entries()) {
      bdtv_1c8a45bd957f.append(bdtv_0469b5764c45, bdtv_d2143a864834);
    }
    return new URLSearchParams(bdtv_1c8a45bd957f).toString();
  }

  onSubmitForm(bdtv_cadf5ba2b99c, bdtv_5c54218ebddf) {
    bdtv_18f3918dec58.renderPage(bdtv_cadf5ba2b99c, bdtv_5c54218ebddf);
  }

  onSubmitHandler(bdtv_cb7d6c484719) {
    bdtv_cb7d6c484719.preventDefault();
    if (bdtv_cb7d6c484719.target.classList.contains("bdt-li-valor")) {
      const bdtv_f51e0348ff1b = Number(document.querySelector(".bdt-di-valor").value);
      const bdtv_ccb5a067453e = Number(bdtv_cb7d6c484719.target.value);
      const bdtv_c83b1cf24964 = Number(bdtv_cb7d6c484719.target.max);
      if (bdtv_ccb5a067453e <= bdtv_f51e0348ff1b || bdtv_ccb5a067453e > bdtv_c83b1cf24964) {
        return;
      }
    }
    const bdtv_e21635644466 = document.querySelectorAll("bdt-faceta2-peneiras-formulario2 form"
    );
    const bdtv_d531932f061f = bdtv_cb7d6c484719.target.closest("form");
    const bdtv_a51e3381a90b = [];
    const bdtv_6f2e227e47d8 = bdtv_d531932f061f.id === "FacetFiltersForm";
    bdtv_e21635644466.forEach((bdtv_b0551850d4de) => {
      if (bdtv_6f2e227e47d8) {
        if (bdtv_b0551850d4de.id === "FacetSortForm" || bdtv_b0551850d4de.id === "FacetFiltersForm") {
          bdtv_a51e3381a90b.push(this.createSearchParams(bdtv_b0551850d4de));
        }
      } else {
        if (
          bdtv_b0551850d4de.id === "FacetSortForm" ||
          bdtv_b0551850d4de.id === "FacetFiltersFormDrawer"
        ) {
          bdtv_a51e3381a90b.push(this.createSearchParams(bdtv_b0551850d4de));
        }
      }
    });
    this.onSubmitForm(bdtv_a51e3381a90b.join("&"), bdtv_cb7d6c484719);
  }

  facetApplyFilter(bdtv_ea85bdc181ee) {
    bdtv_ea85bdc181ee.preventDefault();
    const bdtv_19f87508b33f = document.querySelector("bdt-faceta2-gaveta");
    const bdtv_cac928e5510d = [];
    const bdtv_aa1b6cdc13b3 = document.querySelectorAll("bdt-faceta2-peneiras-formulario2 form"
    );
    bdtv_aa1b6cdc13b3.forEach((bdtv_429b546c1bd6) => {
      if (bdtv_429b546c1bd6.id === "FacetSortForm" || bdtv_429b546c1bd6.id === "FacetFiltersFormDrawer") {
        bdtv_cac928e5510d.push(this.createSearchParams(bdtv_429b546c1bd6));
      }
    });
    this.onSubmitForm(bdtv_cac928e5510d.join("&"), bdtv_ea85bdc181ee);
    bdtv_1eba8d5ad935(bdtv_19f87508b33f, "close");
  }

  onActiveFilterClick(bdtv_b157243ade6a) {
    bdtv_b157243ade6a.preventDefault();
    bdtv_18f3918dec58.toggleActiveFacets();
    const bdtv_fdd0a80bb68a =
      bdtv_b157243ade6a.currentTarget.href.indexOf("?") == -1
        ? ""
        : bdtv_b157243ade6a.currentTarget.href.slice(
            bdtv_b157243ade6a.currentTarget.href.indexOf("?") + 1
          );
    bdtv_18f3918dec58.renderPage(bdtv_fdd0a80bb68a);
  }
}

bdtv_18f3918dec58.filterData = [];
bdtv_18f3918dec58.searchParamsInitial = window.location.search.slice(1);
bdtv_18f3918dec58.searchParamsPrev = window.location.search.slice(1);
customElements.define("bdt-faceta2-peneiras-formulario2", bdtv_18f3918dec58);
bdtv_18f3918dec58.setListeners();

class bdtv_18bf1ff03b0b extends HTMLElement {
  constructor() {
    super();
    this.adjustToValidValues();
  }
  countPercentMin(bdtv_753120e1fee3) {
    const bdtv_6d79bf1f3247 = this.dataset?.bdtSokoLi;
    if (!bdtv_6d79bf1f3247 || bdtv_6d79bf1f3247 === 0) return;
    let bdtv_38e1bd16449c = 0;
    if (bdtv_753120e1fee3 || bdtv_6d79bf1f3247 !== 0) {
      bdtv_38e1bd16449c = (bdtv_753120e1fee3 / bdtv_6d79bf1f3247) * 100;
    }
    this.style.setProperty("--bdt-range-from", bdtv_38e1bd16449c + "%");
    if (Number(bdtv_38e1bd16449c) > Number(this.getValue("--bdt-range-to", this))) {
      this.style.setProperty("--bdt-range-to", bdtv_38e1bd16449c + "%");
    }
  }
  countPercentMax(bdtv_4cf5ca047d70) {
    const bdtv_414fdc739476 = this.dataset?.bdtSokoLi;
    if (!bdtv_414fdc739476 || bdtv_414fdc739476 === 0) return;
    let bdtv_0795d96e8629 = 0;
    if (bdtv_4cf5ca047d70 || bdtv_414fdc739476 !== 0) {
      bdtv_0795d96e8629 = (bdtv_4cf5ca047d70 / bdtv_414fdc739476) * 100;
    }
    this.style.setProperty("--bdt-range-to", bdtv_0795d96e8629 + "%");
    if (Number(this.getValue("--bdt-range-from", this)) > Number(bdtv_0795d96e8629)) {
      this.style.setProperty("--bdt-range-from", bdtv_0795d96e8629 + "%");
    }
  }
  getValue(bdtv_559e3ca9870c, bdtv_61c46d083d67) {
    var bdtv_de258dfc2162 = getComputedStyle(bdtv_61c46d083d67);
    var bdtv_bfc3b9ebc284 = bdtv_de258dfc2162.getPropertyValue(bdtv_559e3ca9870c);
    return bdtv_bfc3b9ebc284.replace("%", "");
  }

  adjustToValidValues() {
    const bdtv_65cc33cc2393 = this;
    var bdtv_f3faa76acbda = this.querySelectorAll("input");
    var bdtv_5f5ca52de39f =
      this.closest("bdt-rine-peneira")?.querySelectorAll("bdt-valor-soko input");
    var bdtv_2b5a4e5c6ad4 = bdtv_f3faa76acbda[0];
    var bdtv_5bddbfa7cbc0 = bdtv_f3faa76acbda[1];
    var bdtv_cb568acefa89 = bdtv_5f5ca52de39f[0];
    var bdtv_711bacdfabc8 = bdtv_5f5ca52de39f[1];
    bdtv_2b5a4e5c6ad4.addEventListener("input", function () {
      bdtv_711bacdfabc8.value =
        parseInt(bdtv_5bddbfa7cbc0.max) == bdtv_5bddbfa7cbc0.value
          ? Number(bdtv_5bddbfa7cbc0.max).toFixed(2)
          : bdtv_5bddbfa7cbc0.value;
      bdtv_cb568acefa89.value =
        parseInt(bdtv_2b5a4e5c6ad4.max) == bdtv_2b5a4e5c6ad4.value
          ? Number(bdtv_2b5a4e5c6ad4.max).toFixed(2)
          : bdtv_2b5a4e5c6ad4.value;
      if (parseInt(bdtv_cb568acefa89.value) > parseInt(bdtv_711bacdfabc8.value)) {
        bdtv_711bacdfabc8.value = Number(bdtv_cb568acefa89.value);
        bdtv_5bddbfa7cbc0.value = Number(bdtv_cb568acefa89.value);
      }
      bdtv_65cc33cc2393.countPercentMin(Number(bdtv_2b5a4e5c6ad4.value));
    });

    bdtv_5bddbfa7cbc0.addEventListener("input", function () {
      bdtv_711bacdfabc8.value =
        parseInt(bdtv_5bddbfa7cbc0.max) == bdtv_5bddbfa7cbc0.value
          ? Number(bdtv_5bddbfa7cbc0.max).toFixed(2)
          : bdtv_5bddbfa7cbc0.value;
      bdtv_cb568acefa89.value =
        parseInt(bdtv_2b5a4e5c6ad4.max) == bdtv_2b5a4e5c6ad4.value
          ? Number(bdtv_2b5a4e5c6ad4.max).toFixed(2)
          : bdtv_2b5a4e5c6ad4.value;
      if (parseInt(bdtv_711bacdfabc8.value) < parseInt(bdtv_cb568acefa89.value)) {
        bdtv_cb568acefa89.value = Number(bdtv_711bacdfabc8.value);
        bdtv_2b5a4e5c6ad4.value = Number(bdtv_711bacdfabc8.value);
      }
      if (parseInt(bdtv_5bddbfa7cbc0.max) == bdtv_5bddbfa7cbc0.value) {
        bdtv_65cc33cc2393.countPercentMax(Number(bdtv_5bddbfa7cbc0.max));
      } else {
        bdtv_65cc33cc2393.countPercentMax(Number(bdtv_5bddbfa7cbc0.value));
      }
    });
  }
}
customElements.define("bdt-valor-soko-nesa", bdtv_18bf1ff03b0b);

class bdtv_856758243301 extends bdtv_18bf1ff03b0b {
  constructor() {
    super();
    this.adjustToValidValues();
    this.priceDrag =
      this.closest("bdt-rine-peneira").querySelector("bdt-valor-soko-nesa");
  }
  countPercentMin(bdtv_70c095b1cbd1) {
    if (!this.priceDrag) return;
    const bdtv_ca999d35a045 = this.priceDrag.dataset?.bdtSokoLi;
    if (!bdtv_ca999d35a045 || bdtv_ca999d35a045 === 0) return;
    let bdtv_1145fd35f802 = 0;
    if (bdtv_70c095b1cbd1 || bdtv_ca999d35a045 !== 0) {
      bdtv_1145fd35f802 = (bdtv_70c095b1cbd1 / bdtv_ca999d35a045) * 100;
    }
    this.priceDrag.style.setProperty("--bdt-range-from", bdtv_1145fd35f802 + "%");
    if (Number(bdtv_1145fd35f802) > Number(this.getValue("--bdt-range-to", this.priceDrag))) {
      this.priceDrag.style.setProperty("--bdt-range-to", bdtv_1145fd35f802 + "%");
    }
  }
  countPercentMax(bdtv_ba36d9ddd8da) {
    if (!this.priceDrag) return;
    const bdtv_7139db00d637 = this.priceDrag.dataset?.bdtSokoLi;
    if (!bdtv_7139db00d637 || bdtv_7139db00d637 === 0) return;
    let bdtv_a1ac23009e6d = 0;
    if (bdtv_ba36d9ddd8da || bdtv_7139db00d637 !== 0) {
      bdtv_a1ac23009e6d = (bdtv_ba36d9ddd8da / bdtv_7139db00d637) * 100;
    }
    this.priceDrag.style.setProperty("--bdt-range-to", bdtv_a1ac23009e6d + "%");
    if (Number(this.getValue("--bdt-range-from", this.priceDrag)) > Number(bdtv_a1ac23009e6d)) {
      this.priceDrag.style.setProperty("--bdt-range-from", bdtv_a1ac23009e6d + "%");
    }
  }
  adjustToValidValues() {
    const bdtv_f32a511e75e2 = this;
    var bdtv_15bce961f8c7 = this.querySelectorAll("input");
    var bdtv_20701baade75 = this.closest("bdt-rine-peneira")?.querySelectorAll("bdt-valor-soko-nesa input"
    );
    var bdtv_f5975908069f = bdtv_20701baade75[0];
    var bdtv_a7c087d2cf46 = bdtv_20701baade75[1];
    var bdtv_867fda7763f1 = bdtv_15bce961f8c7[0];
    var bdtv_b890590b5883 = bdtv_15bce961f8c7[1];
    bdtv_867fda7763f1.addEventListener("keydown", function (bdtv_813a507df1a9) {
      if (bdtv_813a507df1a9.key === "e" || bdtv_813a507df1a9.key === "+" || bdtv_813a507df1a9.key === "-")
        bdtv_813a507df1a9.preventDefault();
    });
    bdtv_867fda7763f1.addEventListener("input", function () {
      if (
        Number(bdtv_867fda7763f1.value) < Number(bdtv_867fda7763f1.min) ||
        bdtv_867fda7763f1.value == ""
      ) {
        bdtv_867fda7763f1.value = bdtv_b890590b5883.min;
      }
      if (bdtv_b890590b5883.value == "") {
        if (bdtv_867fda7763f1.value > Number(bdtv_b890590b5883.max)) {
          bdtv_867fda7763f1.value = bdtv_b890590b5883.max;
        }
      } else {
        if (bdtv_867fda7763f1.value > Number(bdtv_b890590b5883.value)) {
          bdtv_867fda7763f1.value = bdtv_b890590b5883.value;
        }
      }
      if (bdtv_867fda7763f1.value != "") {
        bdtv_f5975908069f.value = Number(bdtv_867fda7763f1.value);
        bdtv_f32a511e75e2.countPercentMin(Number(bdtv_867fda7763f1.value));
      }
    });
    bdtv_b890590b5883.addEventListener("keydown", function (bdtv_6f0da3acf49b) {
      if (bdtv_6f0da3acf49b.key === "e" || bdtv_6f0da3acf49b.key === "+" || bdtv_6f0da3acf49b.key === "-")
        bdtv_6f0da3acf49b.preventDefault();
    });
    bdtv_b890590b5883.addEventListener("blur", function () {
      if (bdtv_b890590b5883.value > Number(bdtv_b890590b5883.max)) {
        bdtv_b890590b5883.value = bdtv_b890590b5883.max;
      } else if (bdtv_b890590b5883.value <= Number(bdtv_867fda7763f1.value)) {
        bdtv_b890590b5883.value = Number(bdtv_867fda7763f1.value) + 1;
      }
      if (bdtv_b890590b5883.value != "") {
        bdtv_a7c087d2cf46.value =
          Number(bdtv_b890590b5883.value) > Number(bdtv_b890590b5883.max)
            ? Number(bdtv_b890590b5883.max).toFixed(2)
            : Number(bdtv_b890590b5883.value);
        bdtv_f32a511e75e2.countPercentMax(Number(bdtv_b890590b5883.value));
      } else {
        bdtv_a7c087d2cf46.value = Number(bdtv_b890590b5883.max).toFixed(2);
        bdtv_f32a511e75e2.countPercentMax(Number(bdtv_b890590b5883.max));
      }
      bdtv_b890590b5883.dispatchEvent(new Event("input", { bubbles: true }));
    });
  }
}
customElements.define("bdt-valor-soko", bdtv_856758243301);

class bdtv_3199829bcab7 extends HTMLElement {
  constructor() {
    super();
    const bdtv_195d95d4be06 = this.querySelector("a");
    bdtv_195d95d4be06.setAttribute("role", "button");
    bdtv_195d95d4be06.addEventListener("click", this.closeFilter.bind(this));
    bdtv_195d95d4be06.addEventListener("keyup", (bdtv_411265ca731c) => {
      bdtv_411265ca731c.preventDefault();
      if (bdtv_411265ca731c.code.toUpperCase() === "SPACE") this.closeFilter(bdtv_411265ca731c);
    });
  }

  closeFilter(bdtv_f9d3ce891003) {
    bdtv_f9d3ce891003.preventDefault();
    const bdtv_e59feb0dd7b8 =
      this.closest("bdt-faceta2-peneiras-formulario2") ||
      document.querySelector("bdt-faceta2-peneiras-formulario2");
    bdtv_e59feb0dd7b8.onActiveFilterClick(bdtv_f9d3ce891003);
  }
}
customElements.define("bdt-faceta2-diva", bdtv_3199829bcab7);

class bdtv_bb9b66887a6a extends HTMLElement {
  constructor() {
    super();
    const bdtv_5fc89487a490 = this;
    this.addEventListener("click", this.closeFilter.bind(this));
    this.addEventListener(
      "keypress",
      function (bdtv_2439837f1817) {
        if (bdtv_2439837f1817.key === "Enter") {
          bdtv_5fc89487a490.closeFilter.bind(bdtv_5fc89487a490)(bdtv_2439837f1817);
        }
      }.bind(bdtv_5fc89487a490),
      false
    );
  }

  closeFilter(bdtv_c72c55db366e) {
    bdtv_c72c55db366e.preventDefault();
    const bdtv_0fdcc7a2cd75 = this.closest("bdt-faceta2-gaveta");
    if (bdtv_0fdcc7a2cd75) {
      bdtv_1eba8d5ad935(bdtv_0fdcc7a2cd75, "close");
    }
  }
}
customElements.define("bdt-faceta2-aplicar2-gaveta", bdtv_bb9b66887a6a);

class bdtv_2364ae6be351 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.activeFilterSort.bind(this), false);
    document.addEventListener(
      "click",
      this.handleClickOutside.bind(this),
      false
    );
    this.addEventListener("keydown", this.handleKeydown.bind(this), false);
  }

  handleKeydown(bdtv_3a259b75b62d) {
    if (bdtv_3a259b75b62d.key === "Enter") {
      bdtv_3a259b75b62d.preventDefault();
      this.activeFilterSort();
    } else if (bdtv_3a259b75b62d.key === "Escape") {
      bdtv_3a259b75b62d.preventDefault();
      this.closeDropdown();
    }
  }

  closeDropdown() {
    const bdtv_2721cd1963ca = this.closest(".bdt-seletor2-proprio");
    if (bdtv_2721cd1963ca && bdtv_2721cd1963ca.classList.contains("bdt-ativo2")) {
      bdtv_2721cd1963ca.classList.remove("bdt-ativo2");
      this.updateFilterSortTabindex(false);
    }
  }

  activeFilterSort() {
    const bdtv_0f230346bf1a = this.closest(".bdt-seletor2-proprio");
    const bdtv_3a4f431a1c30 = bdtv_0f230346bf1a.classList.contains("bdt-ativo2");
    bdtv_0f230346bf1a.classList.toggle("bdt-ativo2");
    this.updateFilterSortTabindex(!bdtv_3a4f431a1c30);
  }

  handleClickOutside(bdtv_6b662918180e) {
    if (!bdtv_6b662918180e.target.closest(".bdt-facetas2-dosu-formulario2")) {
      document.querySelectorAll(".bdt-facetas2-dosu-formulario2").forEach((bdtv_e67d2e82b160) => {
        bdtv_e67d2e82b160.querySelector(".bdt-seletor2-proprio").classList.remove("bdt-ativo2");
        const bdtv_8a351ac5a519 = bdtv_e67d2e82b160.querySelector(".bdt-seletor2-proprio");
        if (!bdtv_8a351ac5a519.classList.contains("bdt-ativo2")) {
          this.updateFilterSortTabindex(false);
        }
      });
    }
  }

  updateFilterSortTabindex(bdtv_ecd670326e02) {
    const bdtv_696ac76ff082 = document.querySelectorAll("bdt-peneira-ordem2");
    bdtv_696ac76ff082.forEach((bdtv_0f4f17279f65) => {
      if (bdtv_ecd670326e02) {
        bdtv_0f4f17279f65.setAttribute("tabindex", "0");
      } else {
        bdtv_0f4f17279f65.removeAttribute("tabindex");
      }
    });
  }
}
customElements.define("bdt-seletor2-peko", bdtv_2364ae6be351);

class bdtv_4be31341b53e extends bdtv_18f3918dec58 {
  constructor() {
    super();
    this.addEventListener("click", this.filterSort.bind(this), false);
    this.addEventListener("keydown", this.handleKeydown.bind(this), false);
  }

  handleKeydown(bdtv_1b75875f313c) {
    if (bdtv_1b75875f313c.key === "Enter") {
      bdtv_1b75875f313c.preventDefault();
      this.filterSort(bdtv_1b75875f313c);
    } else if (bdtv_1b75875f313c.key === "Escape") {
      bdtv_1b75875f313c.preventDefault();
      this.closeDropdownAndUpdateTabindex();
    }
  }

  filterSort(bdtv_dbf9209d5786) {
    bdtv_dbf9209d5786?.preventDefault();
    const bdtv_4b37afb3b40a = document.querySelector("select.bdt-faceta2-peneiras__seletor2");
    const bdtv_da4a05d3c618 = this.getAttribute("value");
    if (bdtv_4b37afb3b40a && bdtv_da4a05d3c618) {
      bdtv_4b37afb3b40a.value = bdtv_da4a05d3c618;
      bdtv_4b37afb3b40a.dispatchEvent(new Event("input", { bubbles: true }));
    }
    this.closeDropdownAndUpdateTabindex();
  }

  closeDropdownAndUpdateTabindex() {
    const bdtv_ee966ad7a1f2 = this.closest(".bdt-faceta2-peneiras");
    if (bdtv_ee966ad7a1f2) {
      bdtv_ee966ad7a1f2.classList.remove("bdt-ativo2");
    }

    this.updateFilterSortTabindex();
    this.focusSelectSorter();
  }

  updateFilterSortTabindex() {
    const bdtv_16a14249245a = document.querySelectorAll("bdt-peneira-ordem2");
    bdtv_16a14249245a.forEach((bdtv_d6434696518d) => {
      bdtv_d6434696518d.removeAttribute("tabindex");
    });
  }

  focusSelectSorter() {
    setTimeout(() => {
      const bdtv_7ccaf16278b7 =
        this.closest(".bdt-faceta2-peneiras")?.querySelector("bdt-seletor2-peko");
      if (bdtv_7ccaf16278b7) {
        bdtv_7ccaf16278b7.focus();
      }
    }, 100);
  }
}
customElements.define("bdt-peneira-ordem2", bdtv_4be31341b53e);

class bdtv_06ff230d12bc extends HTMLElement {
  constructor() {
    super();
    this.FacetsDrawer = document.getElementById("FacetsDrawer");
    this.FacetsDrawer.addEventListener(
      "click",
      this.openDrawer.bind(this),
      false
    );
    this.init();
  }

  init() {
    const bdtv_78e58c829b99 = document.querySelector("bdt-faceta2-gaveta");
    const bdtv_84c83f3a6c90 = this.dataset.bdtArranjo;
    if (bdtv_84c83f3a6c90 == "vertical") {
      let bdtv_2c86fce04a81 = window.innerWidth;
      window.addEventListener("resize", () => {
        const bdtv_bb647a83a8fd = window.innerWidth;
        if (bdtv_bb647a83a8fd > 1024 && bdtv_2c86fce04a81 <= 1024) {
          bdtv_1eba8d5ad935(bdtv_78e58c829b99, "close");
        }
        bdtv_2c86fce04a81 = bdtv_bb647a83a8fd;
      });
    }
  }

  openDrawer() {
    bdtv_35b0c8a58aef.getBody().appendChild(this);
    setTimeout(() => {
      this.FacetsDrawer.classList.add("bdt-ativo2");
      const bdtv_f7606f39512d = document.querySelector("bdt-faceta2-gaveta");
      bdtv_1eba8d5ad935(bdtv_f7606f39512d, "open", true, null, false, false);
      bdtv_35b0c8a58aef.global.rootToFocus = this.FacetsDrawer;
    }, 100);
  }
}
customElements.define("bdt-faceta2-gaveta", bdtv_06ff230d12bc);

class bdtv_7d0a25b64aec extends bdtv_18f3918dec58 {
  constructor() {
    super();
    this.addEventListener("click", this.facetApplyFilter.bind(this), false);
  }
}
customElements.define("bdt-faceta2-aplicar2-zimu", bdtv_7d0a25b64aec);

class bdtv_9a3b9660e29d extends HTMLButtonElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.addEventListener("click", this.ShowMoreFilter.bind(this));
  }

  ShowMoreFilter() {
    const bdtv_ffcb87ec263e = this;
    const bdtv_ca3efba2bd23 =
      this.closest(".bdt-peneira-zide").querySelectorAll(".bdt-oculto2-no-vo");
    if (bdtv_ffcb87ec263e.classList.contains("bdt-pi-vo")) {
      bdtv_ffcb87ec263e.classList.remove("bdt-pi-vo");
      bdtv_ffcb87ec263e.classList.add("bdt-pi-vilu");
      bdtv_ca3efba2bd23.forEach((bdtv_de734370c36d) => {
        bdtv_de734370c36d.classList.remove("bdt-oculto2");
      });
    } else {
      bdtv_ffcb87ec263e.classList.add("bdt-pi-vo");
      bdtv_ffcb87ec263e.classList.remove("bdt-pi-vilu");
      bdtv_ca3efba2bd23.forEach((bdtv_97fdf76bc6f4) => {
        bdtv_97fdf76bc6f4.classList.add("bdt-oculto2");
      });
    }
  }
}
customElements.define("bdt-pi-vo-gatilho", bdtv_9a3b9660e29d, {
  extends: "button",
});
bdtv_36cb401d2a50.observeAndPatchCustomElements({
  "bdt-pi-vo-gatilho": {
    tagElement: "button",
    classElement: bdtv_9a3b9660e29d,
  },
});

class bdtv_8227265cfa3b extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.fetchData.bind(this), false);
    this.addEventListener("keydown", (bdtv_f71e97b419cd) => {
      if (bdtv_f71e97b419cd.key === "Enter") {
        this.fetchData(bdtv_f71e97b419cd);
      }
    });
  }

  connectedCallback() {
    if (this.dataset.bdtPaginado == "infinity") {
      Motion.inView(this, this.fetchData.bind(this), {
        margin: "100px 0px -10px 0px",
      });
    }
  }

  fetchData() {
    const bdtv_9ad7890202c4 = window.location.href;
    const bdtv_a771859d5ad5 = window.location.search;
    let bdtv_73b06367b154 = this.dataset.bdtMipo;
    if (!bdtv_73b06367b154) return;
    if (bdtv_a771859d5ad5.length > 0) {
      bdtv_73b06367b154 = bdtv_9ad7890202c4 + bdtv_73b06367b154.replaceAll("?", "&");
    }
    this.classList.add("bdt-carregando2");
    fetch(bdtv_73b06367b154)
      .then((bdtv_b97468ae347d) => bdtv_b97468ae347d.text())
      .then((bdtv_fc00e9cae67e) => {
        const bdtv_2a31467845e2 = new DOMParser().parseFromString(bdtv_fc00e9cae67e, "text/html");
        const bdtv_96bb2be04d32 = bdtv_2a31467845e2.querySelectorAll("#product-grid .bdt-artigo-item"
        );
        bdtv_96bb2be04d32.forEach((bdtv_13e9445c146e) =>
          document.querySelector("#product-grid").appendChild(bdtv_13e9445c146e)
        );
        document.querySelector(".bdt-paginado-no-vo").innerHTML =
          bdtv_2a31467845e2.querySelector(".bdt-paginado-no-vo").innerHTML;
        new bdtv_3710caabd7c0(".bdt-figura-zora-no");
        document
          .querySelector("#CollectionGird")
          .querySelector("bdt-rari-gali-efeito2")
          ?.reloadAnimationEffect();
      })
      .finally(() => {
        this.classList.remove("bdt-carregando2");
      })
      .catch((bdtv_937185821ebb) => {
        console.error(bdtv_937185821ebb);
      });
  }
}
if (!customElements.get("bdt-bapo-gatilho")) {
  customElements.define("bdt-bapo-gatilho", bdtv_8227265cfa3b);
}

class bdtv_517a8131ad8a extends HTMLElement {
  constructor() {
    super();
    this.isSticky = false;
    this.toolbarHeight = 0;
    this.triggerPosition = 0;

    this.init();
    this.bindEvents();
  }

  init() {
    if (window.innerWidth >= 1024.98) {
      return;
    }

    requestAnimationFrame(() => {
      this.toolbarHeight = this.offsetHeight;

      this.calculateTriggerPosition();

      bdtv_35b0c8a58aef.getBody().style.setProperty(
        "--bdt-sticky-toolbar-height",
        this.toolbarHeight + "px"
      );

      this.checkInitialStickyState();
    });
  }

  checkInitialStickyState() {
    const bdtv_1dd538bf7aa0 = (bdtv_11e28379aaef = 0, bdtv_9457cfbea3d6 = 5, bdtv_b962bff2ab61 = 1) => {
      setTimeout(() => {
        this.calculateTriggerPosition();

        const bdtv_f8c820529004 = window.scrollY;
        if (bdtv_f8c820529004 > this.triggerPosition && !this.isSticky) {
          this.activateSticky();
        } else if (bdtv_b962bff2ab61 < bdtv_9457cfbea3d6) {
          bdtv_1dd538bf7aa0(bdtv_11e28379aaef * 2 || 50, bdtv_9457cfbea3d6, bdtv_b962bff2ab61 + 1);
        }
      }, bdtv_11e28379aaef);
    };

    bdtv_1dd538bf7aa0();
  }

  calculateTriggerPosition() {
    const bdtv_816c2dc8e0e6 = document.querySelectorAll(".shopify-section");
    let bdtv_04a73d745ef3 = 0;

    let bdtv_90fe58db21db = null;
    for (const bdtv_7d44620cd885 of bdtv_816c2dc8e0e6) {
      if (bdtv_7d44620cd885.contains(this)) {
        bdtv_90fe58db21db = bdtv_7d44620cd885;
        break;
      }
    }

    for (const bdtv_287addfc44a7 of bdtv_816c2dc8e0e6) {
      if (bdtv_287addfc44a7 === bdtv_90fe58db21db) {
        if (bdtv_287addfc44a7.classList.contains("shopify-section-search")) {
          const bdtv_c5a635809813 = bdtv_287addfc44a7.querySelector(".bdt-titulo2-envelope-ni-atalho"
          );
          if (bdtv_c5a635809813) {
            bdtv_04a73d745ef3 += bdtv_c5a635809813.offsetHeight;
          }
        }
        const bdtv_5514198c0f27 = bdtv_287addfc44a7.querySelector(".bdt-linha2-etapas2");
        if (bdtv_5514198c0f27) {
          bdtv_04a73d745ef3 += bdtv_5514198c0f27.offsetHeight;
        }
        break;
      }

      const bdtv_9924145d5e45 = bdtv_287addfc44a7.compareDocumentPosition(this);

      if (bdtv_9924145d5e45 & Node.DOCUMENT_POSITION_FOLLOWING) {
        if (bdtv_287addfc44a7.classList.contains("shopify-section-search")) {
          const bdtv_5f9748720557 = bdtv_287addfc44a7.querySelector(".bdt-titulo2-envelope-ni-atalho"
          );
          if (bdtv_5f9748720557) {
            bdtv_04a73d745ef3 += bdtv_5f9748720557.offsetHeight;
          }
        } else {
          bdtv_04a73d745ef3 += bdtv_287addfc44a7.offsetHeight;
        }
        const bdtv_5ee61be17810 = bdtv_287addfc44a7.querySelector(".bdt-linha2-etapas2");
        if (bdtv_5ee61be17810) {
          bdtv_04a73d745ef3 += bdtv_5ee61be17810.offsetHeight;
        }
      }
    }

    this.triggerPosition = bdtv_04a73d745ef3;
  }

  bindEvents() {
    let bdtv_1299c9f2912b = false;

    const bdtv_cd2527b85393 = () => {
      if (!bdtv_1299c9f2912b) {
        requestAnimationFrame(() => {
          this.onScroll();
          bdtv_1299c9f2912b = false;
        });
        bdtv_1299c9f2912b = true;
      }
    };

    window.addEventListener("scroll", bdtv_cd2527b85393);
    window.addEventListener("resize", () => {
      this.init();
    });
  }

  onScroll() {
    if (window.innerWidth >= 1024.98) {
      if (this.isSticky) {
        this.deactivateSticky();
      }
      return;
    }

    const bdtv_86d3c5cd1fe5 = window.scrollY;
    const bdtv_6249520c22a4 = bdtv_86d3c5cd1fe5 > this.triggerPosition;

    if (bdtv_6249520c22a4 && !this.isSticky) {
      this.activateSticky();
    } else if (!bdtv_6249520c22a4 && this.isSticky) {
      this.deactivateSticky();
    }
  }

  activateSticky() {
    this.isSticky = true;
    bdtv_35b0c8a58aef.getBody().classList.add("bdt-go-fixado-barra");
    bdtv_35b0c8a58aef.getBody().style.setProperty(
      "--bdt-sticky-toolbar-height",
      this.toolbarHeight + "px"
    );
  }

  deactivateSticky() {
    this.isSticky = false;
    bdtv_35b0c8a58aef.getBody().classList.remove("bdt-go-fixado-barra");
  }
}

customElements.define("bdt-fixado-barra", bdtv_517a8131ad8a);
